import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-ink px-5 py-12 text-center sm:px-8" data-id="element-141" data-mp="32wd2qgad7ltj">
      <p className="text-lg font-extrabold uppercase tracking-[0.12em] text-ember sm:text-xl" data-id="element-142" data-mp="3ggtxuh7dth4p">
        🏀 Basketball Ready 360™
      </p>
      <p className="mt-4 text-sm font-bold text-white" data-id="element-143" data-mp="36pftnw4hjt58">
        The #1 system for basketball coaches worldwide.
      </p>
      <p className="mt-3 text-xs italic text-neutral-400" data-id="element-144" data-mp="3ueigrjhw2e74">
        Because coaching shouldn't cost you every evening of the week.
      </p>

      <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-neutral-300" data-id="element-145" data-mp="37xxwn1zmcl6">
        <li data-id="element-146" data-mp="3lgosmvua2qv1">
          <a href="mailto:support.basketballready360@gmail.com" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-147" data-mp="3qd6qdbr6xoxv">
            📧 support.basketballready360@gmail.com
          </a>
        </li>
        <li aria-hidden="true" className="text-neutral-600" data-id="element-148" data-mp="2ezuupo5l4cms">
          ·
        </li>
        <li data-id="element-149" data-mp="3lalkbra34rzr">📲 @basketballready360</li>
        <li aria-hidden="true" className="text-neutral-600" data-id="element-150" data-mp="3lbmw5xyxdiij">
          ·
        </li>
        <li data-id="element-151" data-mp="3gca5f24xnrao">🌐 www.basketballready360.com</li>
      </ul>
    </footer>;
}